export const partnersTexts = {
    en: {
        title: 'Global Partners',
        cta: 'FOLLOW',
        headings: {
            spotlight: 'Spotlight partner',
            region: 'Region',
            focus: 'Focus',
            since: 'Since'
        },
        categories: {
            media: '—Media—',
            furnaces: '—Furnaces—',
            cleaning: '—Cleaning—'
        },
        items: {
            bongroup: {
                name: 'BON Group',
                desc: 'Quenching media & stop-off paint',
                description: 'BON Group formulates low-residue quenching media that keep aerospace alloys pristine while maintaining predictable distortion windows.',
                strengths: [
                    'Low residue formula',
                    'IFHTSE compliance',
                    '24/7 remote chemists'
                ],
                metrics: {
                    region: 'Germany',
                    focus: 'Surface chemistry',
                    since: '1949'
                },
                link: 'https://www.bongroup.de/en/'
            },
            codere: {
                name: 'CODERE',
                desc: 'Bottom-load multi atmosphere furnace',
                description: 'CODERE’s modular furnaces synchronize multi-atmosphere recipes, enabling seamless carburizing, carbonitriding, and in-line quenching.',
                strengths: ['Modular cells', 'Smart loading', 'Realtime diagnostics'],
                metrics: {
                    region: 'Switzerland',
                    focus: 'Thermal systems',
                    since: '1981'
                },
                link: 'https://www.codere.ch/en'
            },
            pyradia: {
                name: 'Pyradia',
                desc: 'Bottom-load atmosphere furnace',
                description: 'Pyradia supplies robust batch furnaces with precise convection control for consistent case depth and throughput.',
                strengths: [
                    'Tight ΔT control',
                    'Industry 4.0 ready',
                    'North America service'
                ],
                metrics: {
                    region: 'Canada',
                    focus: 'Atmosphere furnace',
                    since: '1973'
                },
                link: 'https://www.pyradia.com/'
            },
            hemo: {
                name: 'HEMO',
                desc: 'Vacuum cleaning machine by solvent',
                description: 'HEMO combines closed-loop solvent cleaning with vacuum drying to leave zero residue on precision geometries.',
                strengths: [
                    'Hermetic process',
                    'Solvent recovery',
                    'Batch traceability'
                ],
                metrics: {
                    region: 'Germany',
                    focus: 'Solvent cleaning',
                    since: '1979'
                },
                link: 'https://hemogmbh.de/en/home/'
            },
            lpw: {
                name: 'LPW',
                desc: 'High precision cleaning machine by water',
                description: 'LPW’s multistage aqueous systems polish turbine blades and e-mobility components with medical-grade cleanliness.',
                strengths: ['Cavitation boost', 'Modular tanks', 'Digital validation'],
                metrics: {
                    region: 'Germany',
                    focus: 'Aqueous cleaning',
                    since: '1968'
                },
                link: 'https://www.lpw-reinigungssysteme.de/?setlang=en'
            },
            mecanolav: {
                name: 'Mecanolav',
                desc: 'Spraying cleaning machine by water',
                description: 'Mecanolav designs compact high-pressure spray cells that integrate directly into lean manufacturing islands.',
                strengths: [
                    'High-pressure jets',
                    'Compact footprint',
                    'Custom tooling'
                ],
                metrics: {
                    region: 'France',
                    focus: 'Spray cleaning',
                    since: '1923'
                },
                link: 'https://mecanolav.com/'
            }
        },
        // Keep detail for initial static render if needed, using reference values from bongroup
        detail: {
            toptitle: 'Spotlight partner',
            title: 'BON Group',
            subtitle: 'Quenching media & stop-off paint',
            description: 'BON Group formulates low-residue quenching media that keep aerospace alloys pristine while maintaining predictable distortion windows.',
            tags: [
                'Low residue formula',
                'IFHTSE compliance',
                '24/7 remote chemists'
            ],
            metrics: {
                region: 'Germany',
                focus: 'Surface chemistry',
                since: '1949'
            }
        }
    },
    zh: {
        title: '我们的合作伙伴',
        cta: '官网直连',
        headings: {
            spotlight: '合作伙伴',
            region: '地区/Region',
            focus: '专注领域/Focus',
            since: '成立年份/Since'
        },
        categories: {
            media: '—介质—',
            furnaces: '—工业炉—',
            cleaning: '—清洗—'
        },
        items: {
            bongroup: {
                name: 'BON Group',
                desc: '淬火介质和防渗涂料',
                description: 'BON Group 配制的低残留淬火介质可保持航空合金的原始状态，同时保持可预测的变形窗口。',
                strengths: ['低残留配方', '符合 IFHTSE 标准', '全天候化学专家'],
                metrics: {
                    region: '德国',
                    focus: '表面化学',
                    since: '1949'
                },
                link: 'https://www.bongroup.de/en/'
            },
            codere: {
                name: 'CODERE',
                desc: '底装料气氛多用炉',
                description: 'CODERE 的模块化炉同步多气氛配方，实现无缝渗碳、碳氮共渗和在线淬火。',
                strengths: ['模块化单元', '智能装载', '实时诊断'],
                metrics: {
                    region: '瑞士',
                    focus: '热系统',
                    since: '1981'
                },
                link: 'https://www.codere.ch/en'
            },
            pyradia: {
                name: 'Pyradia',
                desc: '底装料气氛炉',
                description: 'Pyradia 提供坚固的箱式炉，具有稳定的对流控制，可实现一致的硬化层深度和产量。',
                strengths: ['严格温差控制', '工业 4.0 就绪', '北美服务'],
                metrics: {
                    region: '加拿大',
                    focus: '气氛炉',
                    since: '1973'
                },
                link: 'https://www.pyradia.com/'
            },
            hemo: {
                name: 'HEMO',
                desc: '溶剂真空清洗机',
                description: 'HEMO 将闭环溶剂清洗与真空干燥相结合，在精密几何形状上实现零残留。',
                strengths: ['气密工艺', '溶剂回收', '批次可追溯'],
                metrics: {
                    region: '德国',
                    focus: '溶剂清洗',
                    since: '1979'
                },
                link: 'https://hemogmbh.de/en/home/'
            },
            lpw: {
                name: 'LPW',
                desc: '高精度水清洗机',
                description: 'LPW 的多级水基系统以医疗级清洁度抛光涡轮叶片和电动汽车组件。',
                strengths: ['空化增强', '模块化槽体', '数字验证'],
                metrics: {
                    region: '德国',
                    focus: '水基清洗',
                    since: '1968'
                },
                link: 'https://www.lpw-reinigungssysteme.de/?setlang=en'
            },
            mecanolav: {
                name: 'Mecanolav',
                desc: '水喷淋清洗机',
                description: 'Mecanolav 设计紧凑的高压喷淋单元，可直接集成到精益制造岛中。',
                strengths: ['高压喷射', '紧凑占地', '定制工装'],
                metrics: {
                    region: '法国',
                    focus: '喷淋清洗',
                    since: '1923'
                },
                link: 'https://mecanolav.com/'
            }
        },
        detail: {
            toptitle: '合作伙伴',
            title: 'BON Group',
            subtitle: '淬火介质和防渗涂料',
            description: 'BON Group 配制的低残留淬火介质可保持航空合金的原始状态，同时保持可预测的变形窗口。',
            tags: ['低残留配方', '符合 IFHTSE 标准', '全天候化学专家'],
            metrics: {
                region: '德国',
                focus: '表面化学',
                since: '1949'
            }
        }
    }
}

export const getPartnersTexts = (lang) => {
    return partnersTexts[lang] || partnersTexts['en']
}